export const ClientDoublesClientIds = {
  clientOwnerInfoCard: 'clientOwnerInfoCard',
  goToClientOnOwnerInfoCard: 'goToClientOnOwnerInfoCard',
  ownerBadge: 'ownerBadge',
  openChangeOwnerModal: 'openChangeOwnerModal',
  changeOwnerModal: 'changeOwnerModal',
  canChangeOwnerSMS: 'canChangeOwnerSMS',
  cannotChangeOwner: 'cannotChangeOwner',
};
